var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4301,
    cy: 17.3208,
    r: 16.1408,
    stroke: "#FDA900",
    strokeWidth: 1.89892
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5254 23.015C25.7787 23.5215 25.5732 24.1375 25.0667 24.3907C24.9194 24.4642 24.7628 24.4988 24.609 24.4988C24.2323 24.4994 23.8704 24.2916 23.6906 23.932C23.6191 23.7919 21.8291 20.3971 17.4301 20.3971C13.031 20.3971 11.241 23.7919 11.1668 23.9365C10.9094 24.4386 10.2949 24.6399 9.79001 24.386C9.28653 24.1313 9.08247 23.5195 9.33472 23.0146C9.43043 22.8239 11.7345 18.3463 17.4301 18.3463C23.1256 18.3463 25.4297 22.8239 25.5254 23.015Z",
    fill: "#FDA900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0933 13.9977C13.2732 13.9977 14.2296 13.0412 14.2296 11.8614C14.2296 10.6815 13.2732 9.7251 12.0933 9.7251C10.9135 9.7251 9.95703 10.6815 9.95703 11.8614C9.95703 13.0412 10.9135 13.9977 12.0933 13.9977Z",
    fill: "#FDA900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7691 13.9977C23.9489 13.9977 24.9054 13.0412 24.9054 11.8614C24.9054 10.6815 23.9489 9.7251 22.7691 9.7251C21.5893 9.7251 20.6328 10.6815 20.6328 11.8614C20.6328 13.0412 21.5893 13.9977 22.7691 13.9977Z",
    fill: "#FDA900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoor);
export default __webpack_public_path__ + "static/media/poor.c8ffd190bef7b7d07540813aa6d5e7b1.svg";
export { ForwardRef as ReactComponent };